

const FirstName = ({ elements, fName, placeholder, setFName }) => {
    return elements.fName && <><input value={fName} type="text" id="fname" name="fname" placeholder={placeholder?.fName} onChange={(e) => setFName(e.target.value)} /></>
}
export default FirstName;